export default [
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
    ],
  },
  {
    for: 'teaser',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'backgroundImage',
    ],
  },
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'showDate',
      'showMore',
      'teaserHeadline',
      'teaserSubHeadline',
      'subHeadline',
      'teaserText',
      'cmsKilldate',
      'cmsLivedate',
      'documents',
      'assetId',
      'assets',
      'linkId',
      'links',
      'products',
    ],
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: [
      'channelsExcluded',
      'channelsExclusive',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'text',
      'copyright',
      'versiontitle',
      'videoIsrc',
      'director',
      'changeDate',
      'externalReferences',
      'ownedByChannel',
      'product',
      'subHeadline',
      'recordPartnerId',
      'products',
    ],
  },
  {
    for: 'asset-token-config',
    actions: {
      create: false,
      update: false,
      read: true,
      delete: false,
    },
    options: {
      canViewNavigation: false,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: ['audioplayerShops', 'subHeadline'],
  },
];
